import { render, staticRenderFns } from "./PhoneCode.vue?vue&type=template&id=70e3139c&scoped=true"
import script from "./PhoneCode.vue?vue&type=script&lang=js"
export * from "./PhoneCode.vue?vue&type=script&lang=js"
import style0 from "./PhoneCode.vue?vue&type=style&index=0&id=70e3139c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e3139c",
  null
  
)

export default component.exports